export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "batch.worker.f1a382b2fe4c3861387d.worker.js");
}
